import {
  SHOW_RESPONSE_MESSAGE,
  HIDE_RESPONSE_MESSAGE,
  GET_RESPONSE,
  GET_RESPONSE_SUCCESS,
  GET_RESPONSE_MODES,
  GET_RESPONSE_MODES_SUCCESS,
  SAVE_RESPONSE,
  SAVE_RESPONSE_SUCCESS,
  SAVE_RESPONSE_MOBILE,
  SAVE_RESPONSE_MOBILE_SUCCESS,
  SAVE_RESPONSE_MOBILE_TOKEN,
  SAVE_RESPONSE_MOBILE_TOKEN_SUCCESS,
  SAVE_RESPONSE_EMAIL,
  SAVE_RESPONSE_EMAIL_SUCCESS,
  SAVE_RESPONSE_EMAIL_TOKEN,
  SAVE_RESPONSE_EMAIL_TOKEN_SUCCESS,
  RETURN_APPLICATION,
  CANCEL_RETURN,
  SAVE_RESPONSE_FILE,
  SAVE_RESPONSE_FILE_SUCCESS,
  SAVE_RESPONSE_SIGNED_FILE,
  SAVE_RESPONSE_SIGNED_FILE_SUCCESS,
  DOWNLOAD_RESPONSE,
  DOWNLOAD_RESPONSE_SUCCESS,
} from '../constants/ActionTypes';

export const getResponse = (param) => {
  return {
    type: GET_RESPONSE,
    payload: param,
  };
};

export const getResponseSuccess = (param) => {
  return {
    type: GET_RESPONSE_SUCCESS,
    payload: param,
  };
};

export const getResponseModes = (param) => {
  return {
    type: GET_RESPONSE_MODES,
    payload: param,
  };
};

export const getResponseModesSuccess = (param) => {
  return {
    type: GET_RESPONSE_MODES_SUCCESS,
    payload: param,
  };
};

export const saveResponse = (param) => {
  return {
    type: SAVE_RESPONSE,
    payload: param,
  };
};

export const saveResponseSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_SUCCESS,
    payload: param,
  };
};

export const saveResponseMobile = (param) => {
  return {
    type: SAVE_RESPONSE_MOBILE,
    payload: param,
  };
};

export const saveResponseMobileSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_MOBILE_SUCCESS,
    payload: param,
  };
};

export const saveResponseMobileToken = (param) => {
  return {
    type: SAVE_RESPONSE_MOBILE_TOKEN,
    payload: param,
  };
};

export const saveResponseMobileTokenSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_MOBILE_TOKEN_SUCCESS,
    payload: param,
  };
};

export const saveResponseEmail = (param) => {
  return {
    type: SAVE_RESPONSE_EMAIL,
    payload: param,
  };
};

export const saveResponseEmailSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_EMAIL_SUCCESS,
    payload: param,
  };
};

export const saveResponseEmailToken = (param) => {
  return {
    type: SAVE_RESPONSE_EMAIL_TOKEN,
    payload: param,
  };
};

export const saveResponseEmailTokenSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_EMAIL_TOKEN_SUCCESS,
    payload: param,
  };
};

export const returnApplication = (param) => {
  return {
    type: RETURN_APPLICATION,
    payload: param,
  };
};

export const cancelReturn = (param) => {
  return {
    type: CANCEL_RETURN,
    payload: param,
  };
};

export const saveResponseFile = (param) => {
  return {
    type: SAVE_RESPONSE_FILE,
    payload: param,
  };
};

export const saveResponseFileSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_FILE_SUCCESS,
    payload: param,
  };
};

export const saveResponseSignedFile = (param) => {
  return {
    type: SAVE_RESPONSE_SIGNED_FILE,
    payload: param,
  };
};

export const saveResponseSignedFileSuccess = (param) => {
  return {
    type: SAVE_RESPONSE_SIGNED_FILE_SUCCESS,
    payload: param,
  };
};

export const showMessage = (param) => {
  return {
    type: SHOW_RESPONSE_MESSAGE,
    payload: param,
  };
};

export const hideMessage = (param) => {
  return {
    type: HIDE_RESPONSE_MESSAGE,
    payload: param,
  };
};

export const downloadResponse = (param) => {
  return {
    type: DOWNLOAD_RESPONSE,
    payload: param,
  };
};

export const downloadResponseSuccess = (param) => {
  return {
    type: DOWNLOAD_RESPONSE_SUCCESS,
    payload: param,
  };
};
